<app-item [class.rounded-border-box]="showBorderBox" [class.active]="!readOnly" (click)="controlClicked($event)">
    <app-item-label class="no-events validation-label">{{label}}</app-item-label>
    <app-item-value class="no-events" [value]="text" [placeholder]="placeholderValue"></app-item-value>
</app-item>